"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomerMembershipContract = void 0;
const contract_1 = require("../base/contract");
const membership_schemas_1 = require("../../schemas/customer/membership.schemas");
const api_schemas_1 = require("../../schemas/base/api.schemas");
/**
 * Customer Membership Contract
 *
 * PRD Notes (FR165-174):
 * - Profile shows list of all merchants user is a member of (FR166)
 * - User can leave a merchant (FR167-174)
 * - Cannot leave if credit_balance > 0 (FR169)
 * - Forfeits points and coupons on leave (FR170-171)
 * - Action is logged in audit log (FR174)
 *
 * serviceModule: 'user' - maps to server-v2/src/modules/user/
 */
exports.CustomerMembershipContract = (0, contract_1.createContract)({
    name: 'CustomerMembership',
    baseUrl: '/memberships',
    version: '1',
    serviceModule: 'user',
    endpoints: {
        listMemberships: {
            method: 'GET',
            path: '/',
            body: null,
            query: membership_schemas_1.listMembershipsQuerySchema,
            params: null,
            headers: null,
            response: {
                success: membership_schemas_1.listMembershipsResponseSchema,
                errors: {
                    unauthorized: api_schemas_1.baseErrorResponseSchema,
                },
            },
            middleware: ['auth:required'],
            documentation: {
                summary: 'List memberships',
                description: 'Retrieves all merchant memberships for the authenticated user with balances',
                tags: ['Customer', 'Membership'],
                deprecated: false,
            },
            tests: ['should return all memberships with balances', 'should return empty list for user with no memberships'],
        },
        getMembershipDetails: {
            method: 'GET',
            path: '/:merchantId',
            body: null,
            query: null,
            params: membership_schemas_1.getMembershipDetailsParamsSchema,
            headers: null,
            response: {
                success: membership_schemas_1.getMembershipDetailsResponseSchema,
                errors: {
                    unauthorized: api_schemas_1.baseErrorResponseSchema,
                    notFound: api_schemas_1.baseErrorResponseSchema, // Not a member of this merchant
                },
            },
            middleware: ['auth:required'],
            documentation: {
                summary: 'Get membership details',
                description: 'Retrieves detailed membership information for a specific merchant',
                tags: ['Customer', 'Membership'],
                deprecated: false,
            },
            tests: ['should return membership details', 'should return 404 for non-member'],
        },
        // ============================================
        // V2 ENDPOINTS (uncomment when ready)
        // ============================================
        /*
        deleteMembership: {
            method: 'DELETE',
            path: '/:merchantId',
            body: null,
            query: null,
            params: deleteMembershipParamsSchema,
            headers: null,
            response: {
                success: deleteMembershipResponseSchema,
                errors: {
                    unauthorized: baseErrorResponseSchema,
                    notFound: baseErrorResponseSchema, // Not a member of this merchant
                    badRequest: baseErrorResponseSchema, // Has credit balance > 0
                },
            },
            middleware: ['auth:required'],
            documentation: {
                summary: 'Leave merchant',
                description:
                    'Leaves a merchant membership. CRITICAL: Returns 400 if credit_balance > 0. Forfeits all points and coupons. Frontend should show warning dialog first.',
                tags: ['Customer', 'Membership'],
                deprecated: false,
            },
            tests: [
                'should leave merchant and return forfeited amounts',
                'should return 400 if credit_balance > 0',
                'should forfeit all points and coupons',
                'should log action in audit log',
                'should return 404 for non-member',
            ],
        },
        */
    },
});
